const getPricePerCode = (price: number, amountOfCodes: number) => {
  let result = 0;
  const tempPrice = price / amountOfCodes;
  if (tempPrice && tempPrice % 1 !== 0) {
    result = +tempPrice.toFixed(1);
  } else {
    result = tempPrice;
  }

  return result;
};

export default getPricePerCode;
